module.exports = __webpack_public_path__ + "resources/images/logo_bydehand_trans-68e940f8bd10e0efeba26e6fd0c6e254-cache.png";